import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Typography } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import UnoButton from "../../utils/UnoButton";
import { unoTheme } from "../../../assets/styles/unoTheme";

//AutoComplete
import TextField from '@material-ui/core/TextField';

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import {
    applyMaskAmount,
    parseFloatByPtCurrency,
    isDateAfterClosedMonth,
    applyMaskAccount, applyMaskAmountFreeDecimals, portfolioClosedToDate, formatPortfolioClosed
} from "../../utils/utils";

import InputAdornment from '@material-ui/core/InputAdornment';

//Api
import { TitleAPI } from '../../../API/title'

import {
    AccountAPI,
} from '../../../API/account'

//MyInputs
import MyTextField from "../../utils/MyTextField";
import MySelect from '../../utils/MySelect'
import MyAutoComplete from '../../utils/MyAutoComplete'
import MyDatePicker from '../../utils/MyDatePicker'

import { checkAssetIsLaunched } from '../../../controllers/AssetsController'

import CircularProgress from '@material-ui/core/CircularProgress';

import _ from 'lodash';
import moment from 'moment'
import MyInfo from "../../utils/MyInfo";
import AddIcon from '@material-ui/icons/Add';

import ConfirmActionRightContent from './ConfirmActionRightContent'

import { getOptionsMarkingTitle, getOptionsSectorTitle, getOptionsIndexersTitle } from '../../utils/paramsToTitles';
import { isConsigTitle, isGenericTitle, needQuotasTitle } from "../../../controllers/TitleController";
import { checkUserIsRole, roles } from "../../utils/user";
import { useMemo } from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3)
    },

    main: {
        height: '100vh',
        display: 'flex',
        overflowY: 'scroll',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingBottom: '24px',
        textAlign: 'left',

        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }

    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    detailRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

    },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    warning: {
        color: unoTheme.warningColor
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    }

}));

export default function NewAsset(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { content } = props

    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');

    const [confirmingAction, setConfirmingAction] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const [allTitles, setAllTitles] = useState([]);

    //Cache de períodos com artigo eletrônico por título (chave = title_id)
    //undefined = ainda não buscado; array = já buscado (pode ser vazio)
    const [eletronicPeriodsByTitleId, setEletronicPeriodsByTitleId] = useState({});

    //cadastrar ativo    
    const [inputAccountNewAsset, setInputAccountNewAsset] = React.useState(undefined);
    const [inputAssetTitleToCreate, setInputAssetTitleToCreate] = React.useState(undefined);
    const [inputQuantityPurchased, setInputQuantityPurchased] = useState("");
    const [inputQuantityInit, setInputQuantityInit] = useState("");

    //atualizar ativos
    const [clientAccounts, setClientAccounts] = useState([]);
    //Para indicar se o ativo já foi lançado alguma vez na carteira do cliente
    //Caso já tenha sido lançado o ativo não pode ser editado
    const [alreadyLaunched, setAlreadyLaunched] = useState(true);
    const [accountToShow, setAccountToShow] = useState(true);

    //Novos campos
    const [titleTypes, setTitleTypes] = useState([]);
    const [optionsMarkings,] = useState(getOptionsMarkingTitle());
    const [inputMarkingTitle, setInputMarkingTitle] = useState(0);
    const [inputPriceTitle, setInputPriceTitle] = useState("");
    const [balanceInit, setBalanceInit] = useState("");
    const [balanceNow, setBalanceNow] = useState("");
    const [applicationValue, setApplicationValue] = useState("");
    const [inputPurchasedDateTitle, setInputPurchasedDateTitle] = useState(new Date());
    const [prevInputPurchasedDateTitle, setPrevInputPurchasedDateTitle] = useState();
    const [inputInitDateAssetTitle, setInputInitDateAssetTitle] = useState(new Date());
    const [prevInputInitDateAssetTitle, setPrevInputInitDateAssetTitle] = useState();
    const [inputPreTaxTitle, setInputPreTaxTitle] = useState("");
    const [inputIndexerPercentTitle, setInputIndexerPercentTitle] = useState("");
    const [inputWithLiquidityTitle, setInputWithLiquidityTitle] = useState(0);
    const [optionsLiquidity,] = useState(['Não', 'Sim']);
    //Aquisição eletrônica (usado no modo update; no create fica em cada form)
    const [inputEletronicAquisition, setInputEletronicAquisition] = useState(0);
    const [optionsYesNo,] = useState(['Não', 'Sim']);
    //trandingNote
    const [inputTradingNote, setInputTradingNote] = useState('');
    //Ativos genérivos ex: imóveis
    const [inputAssetNameTitle, setInputAssetNameTitle] = useState('');
    const [inputAssetDescriptionTitle, setInputAssetDescriptionTitle] = useState('');

    //update account
    const [edittingAccount, setEdittingAccount] = useState(false);

    // Multi-form para CREATE
    const defaultAssetTitleForm = {
        inputAssetTitleToCreate: undefined,
        inputQuantityPurchased: "",
        inputQuantityInit: "",
        inputMarkingTitle: 0,
        inputPriceTitle: "",
        balanceInit: "",
        balanceNow: "",
        applicationValue: "",
        inputPurchasedDateTitle: new Date(),
        prevInputPurchasedDateTitle: undefined,
        inputInitDateAssetTitle: new Date(),
        prevInputInitDateAssetTitle: undefined,
        inputPreTaxTitle: "",
        inputIndexerPercentTitle: "",
        inputWithLiquidityTitle: 0,
        eletronicAquisition: 0,
        inputTradingNote: '',
        inputAssetNameTitle: '',
        inputAssetDescriptionTitle: '',
        inputAssetIssueDateTitle: null,
        inputAssetSaleOffDateTitle: null,
        inputAssetDueDateTitle: null,
        inputAccountNewAsset: undefined,
    };
    const [assetTitleForms, setAssetTitleForms] = useState([{ ...defaultAssetTitleForm }]);

    //datas do ativo, exibidas em caso de título privados
    const [inputAssetIssueDateTitle, setInputAssetIssueDateTitle] = useState(null);
    const [inputAssetSaleOffDateTitle, setInputAssetSaleOffDateTitle] = useState(null);
    const [inputAssetDueDateTitle, setInputAssetDueDateTitle] = useState(null);


    const doUpdateAccount = async () => {

        setValidationMessage('')
        setOpenBackdrop(true)
        if (clientAccounts?.[inputAccountNewAsset]?.id) {

            const response = await TitleAPI.updateAccountAssetTitle(content.data.id, clientAccounts[inputAccountNewAsset].id);
            if (response.success) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: 'Conta atualizada com sucesso!'
                }));
            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: 'Falha ao atualizar conta do ativo.'
                }));
            }

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Conta inconsistente'
            }));

        }

        setEdittingAccount(false);
        setOpenBackdrop(false);

    }

    async function doCreateAllAssetTitles() {

        const savedIndexes = [];
        // Fase 1: validar todos os formulários antes de salvar qualquer um
        const validationErrors = [];

        for (let i = 0; i < assetTitleForms.length; i++) {
            const form = assetTitleForms[i];

            const accountMissing = form.inputAccountNewAsset == null || form.inputAccountNewAsset === '';
            if (accountMissing
                || !form.inputAssetTitleToCreate?.id
                || form.inputQuantityPurchased == ""
                || form.inputPriceTitle == ""
                || form.inputMarkingTitle == null
                || !moment(form.inputPurchasedDateTitle).isValid()
            ) {
                validationErrors.push(`Formulário ${i + 1}: campos obrigatórios não preenchidos`);
                continue;
            }

            if (!isGenericTitle(form.inputAssetTitleToCreate) && form.inputAssetTitleToCreate.sector == "PRIVADO") {
                if ((form.inputAssetIssueDateTitle != null && !moment(form.inputAssetIssueDateTitle).isValid())
                    || (form.inputAssetSaleOffDateTitle != null && !moment(form.inputAssetSaleOffDateTitle).isValid())
                    || (form.inputAssetDueDateTitle != null && !moment(form.inputAssetDueDateTitle).isValid())) {
                    validationErrors.push(`Formulário ${i + 1}: informe datas válidas para o ativo`);
                    continue;
                }
            }

            const endOfNextMonth = moment.utc(form.inputInitDateAssetTitle).add(1, 'month').endOf('month');

            if (clientOn.client.portfolio_closed
                && moment.utc(form.inputInitDateAssetTitle).isBefore(moment.utc(portfolioClosedToDate(clientOn.client.portfolio_closed)).clone().subtract(1, 'month'))) {
                validationErrors.push(`Formulário ${i + 1}: a data de início da carteira deve ser superior ao fechamento > ` + formatPortfolioClosed(clientOn.client.portfolio_closed));
                continue;
            }

            if (moment.utc(form.inputPurchasedDateTitle).isAfter(endOfNextMonth)) {
                validationErrors.push(`Formulário ${i + 1}: a data de compra deve ser ≤ ao último dia do mês seguinte ao início da carteira: ` + endOfNextMonth.format('DD/MM/YYYY'));
                continue;
            }

            if (form.inputAssetTitleToCreate.due_date && moment(form.inputAssetTitleToCreate.due_date).isBefore(form.inputPurchasedDateTitle)) {
                validationErrors.push(`Formulário ${i + 1}: a data da compra deve ser anterior ao vencimento do título`);
                continue;
            }
            if (moment.utc(form.inputPurchasedDateTitle).isSame(moment.utc(form.inputInitDateAssetTitle), 'month')) {
                validationErrors.push(`Formulário ${i + 1}: a data de compra não pode estar no mesmo mês do início da carteira`);
                continue;
            }

            //Compra anterior ao mês de início não gera movimentação de aplicação (ver
            //shouldCreateTransaction em title.controller.js): o saldo do mês de início é o único
            //portador da posição do ativo, então nesse caso ele é obrigatório
            if (moment.utc(form.inputPurchasedDateTitle).isBefore(moment.utc(form.inputInitDateAssetTitle).startOf('month'))
                && (form.balanceInit == null || form.balanceInit === "")) {
                validationErrors.push(`Formulário ${i + 1}: informe o saldo de início na carteira (a compra é anterior ao início e não haverá movimentação de aplicação)`);
                continue;
            }
        }

        if (validationErrors.length > 0) {
            setValidationMessage(validationErrors.join(' | '));
            setOpenBackdrop(false);
            return;
        }

        // Fase 2: todos válidos, salvar sequencialmente
        const saveErrors = [];

        for (let i = 0; i < assetTitleForms.length; i++) {
            const form = assetTitleForms[i];

            const assetTitle = {
                account_id: clientAccounts[form.inputAccountNewAsset].id,
                title_id: form.inputAssetTitleToCreate.id,
                quantity_purchased: parseFloatByPtCurrency(form.inputQuantityPurchased),
                marking: optionsMarkings[form.inputMarkingTitle],
                purchase_date: moment.utc(form.inputPurchasedDateTitle).format("DD/MM/YYYY"),
                prev_purchase_date: moment.utc(form.inputPurchasedDateTitle).format("DD/MM/YYYY"),
                price_title: parseFloatByPtCurrency(form.inputPriceTitle),
                pre_tax: form.inputPreTaxTitle && form.inputPreTaxTitle != "" ? parseFloatByPtCurrency(form.inputPreTaxTitle) : null,
                indexer_percent: form.inputIndexerPercentTitle && form.inputIndexerPercentTitle != "" ? parseFloatByPtCurrency(form.inputIndexerPercentTitle) : null,
                with_liquidity: form.inputWithLiquidityTitle == 0 ? false : true,
                asset_title_issue_date: form.inputAssetIssueDateTitle ? moment.utc(form.inputAssetIssueDateTitle).format("DD/MM/YYYY") : null,
                asset_title_sale_off_date: form.inputAssetSaleOffDateTitle ? moment.utc(form.inputAssetSaleOffDateTitle).format("DD/MM/YYYY") : null,
                asset_title_due_date: form.inputAssetDueDateTitle ? moment.utc(form.inputAssetDueDateTitle).format("DD/MM/YYYY") : null,
                asset_title_init: form.inputInitDateAssetTitle ? moment.utc(form.inputInitDateAssetTitle).format("DD/MM/YYYY") : null,
                prev_asset_title_init: form.inputInitDateAssetTitle ? moment.utc(form.inputInitDateAssetTitle).format("DD/MM/YYYY") : null,
                balance_now: form.balanceNow ? parseFloatByPtCurrency(form.balanceNow) : null,
                balance_init: form.balanceInit ? parseFloatByPtCurrency(form.balanceInit) : null,
                quantity_init: form.inputQuantityInit ? parseFloatByPtCurrency(form.inputQuantityInit) : null,
                same_account: clientAccounts[form.inputAccountNewAsset].id == content.data.selectedAccountId,
                trading_note: form.inputTradingNote,
                asset_name: form.inputAssetNameTitle,
                asset_description: form.inputAssetDescriptionTitle,
                eletronic_aquisition: form.eletronicAquisition == 1,
            };

            const response = await TitleAPI.createAssetTitle(assetTitle);
            if (response.success) {
                savedIndexes.push(i);
            } else {
                saveErrors.push(`Formulário ${i + 1}: ` + (response.body?.message || 'Erro ao cadastrar'));
            }
        }

        if (saveErrors.length > 0) {
            setValidationMessage(saveErrors.join(' | '));
        }

        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: saveErrors.length === 0 ? 'success' : 'warning',
            message: saveErrors.length === 0
                ? (savedIndexes.length === 1 ? 'Ativo cadastrado com sucesso!' : `${savedIndexes.length} ativos cadastrados com sucesso!`)
                : `${savedIndexes.length} de ${assetTitleForms.length} ativos cadastrados com sucesso.`
        }));

        setSubmitted(false);

        if (saveErrors.length > 0) {
            //Mantém o painel aberto para o usuário ler o motivo: o dispatch de update reseta o
            //rightContent (reducers/rightContent.js) e desmontaria o formulário junto com o
            //validationMessage. Os formulários já gravados saem da lista para que uma nova
            //tentativa não duplique os ativos que passaram.
            setAssetTitleForms(prev => prev.filter((_, i) => !savedIndexes.includes(i)));
        } else {
            dispatch(allActions.rightContentActions.update());
        }

        setOpenBackdrop(false);
    }

    async function doSaveClientAsset() {

        setValidationMessage('')
        setSubmitted(true);
        setOpenBackdrop(true)

        if (!content.update) {
            await doCreateAllAssetTitles();
            return;
        }

        if (inputAccountNewAsset !== null
            && inputAssetTitleToCreate.id
            && inputQuantityPurchased != ""
            && inputPriceTitle != ""
            && inputMarkingTitle != null
            && moment(inputPurchasedDateTitle).isValid()
        ) {

            // Detecta se a única alteração foi o preço do título
            const sameAccount = !inputAccountNewAsset ||
                (clientAccounts[inputAccountNewAsset]?.id === content.data?.account_id);
            const onlyPriceTitleChanged = content.update
                && parseFloatByPtCurrency(inputPriceTitle) !== parseFloat(content.data.price_title)
                && sameAccount
                && parseFloatByPtCurrency(inputQuantityPurchased) === parseFloat(content.data.quantity_purchased)
                && optionsMarkings[inputMarkingTitle] === content.data.marking
                && moment.utc(inputPurchasedDateTitle).isSame(moment.utc(content.data.purchase_date), 'day')
                && moment.utc(inputInitDateAssetTitle).isSame(moment.utc(content.data.asset_title_init), 'day');

            // Detecta se a única alteração foi a data de compra do título
            const onlyPurchasedDateChanged = content.update
                && !moment.utc(inputPurchasedDateTitle).isSame(moment.utc(content.data.purchase_date), 'day')
                && sameAccount
                && parseFloatByPtCurrency(inputPriceTitle) === parseFloat(content.data.price_title)
                && parseFloatByPtCurrency(inputQuantityPurchased) === parseFloat(content.data.quantity_purchased)
                && optionsMarkings[inputMarkingTitle] === content.data.marking
                && moment.utc(inputInitDateAssetTitle).isSame(moment.utc(content.data.asset_title_init), 'day');

            if (!onlyPriceTitleChanged) {

                if (!onlyPurchasedDateChanged && !isGenericTitle(inputAssetTitleToCreate)) {
                    if (inputAssetTitleToCreate.sector == "PRIVADO") {

                        if ((inputAssetIssueDateTitle != null && !moment(inputAssetIssueDateTitle).isValid())
                            || (inputAssetSaleOffDateTitle != null && !moment(inputAssetSaleOffDateTitle).isValid())
                            || (inputAssetDueDateTitle != null && !moment(inputAssetDueDateTitle).isValid())) {

                            dispatch(allActions.mainAlertActions.setMainAlert({
                                show: true,
                                type: 'warning',
                                message: 'Informe datas válidas para o ativo'
                            }));

                            setOpenBackdrop(false)

                            return;
                        }

                    }
                }

                //dia máximo para aplicação, o último dia do mÊs seguinte ao mês de inicio na carteira
                const endOfNextMonth = moment.utc(inputInitDateAssetTitle).add(1, 'month').endOf('month');

                //O título deve ser comparado appós a última carteira fechada
                if (!onlyPurchasedDateChanged && clientOn.client.portfolio_closed && moment.utc(inputInitDateAssetTitle).isBefore(moment.utc(portfolioClosedToDate(clientOn.client.portfolio_closed)).clone().subtract(1, 'month'))) {

                    if (moment.utc(inputPurchasedDateTitle).isBefore(inputInitDateAssetTitle) && content.update) {
                        //deixa passar pois vai ser removida uma movimentação
                    } else {

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'warning',
                            message: 'A data de início da carteira deve ser superior ao fechamento da carteira do cliente > ' + formatPortfolioClosed(clientOn.client.portfolio_closed)
                        }));

                        setOpenBackdrop(false)
                        return;
                    }
                }

                //A data de compra deve ser <= ao mês seguinte do início da carteira            
                if (moment.utc(inputPurchasedDateTitle).isAfter(endOfNextMonth)) {
                    // dispatch(allActions.mainAlertActions.setMainAlert({
                    //     show: true,
                    //     type: 'warning',
                    //     message: 'A data de compra do título deve ser menor ou igual ao último dia do mês seguinte após o início da carteira: ' + endOfNextMonth.format('DD/MM/YYYY')
                    // }));

                    setOpenBackdrop(false)
                    setValidationMessage('A data de compra do título deve ser menor ou igual ao último dia do mês seguinte após o início da carteira: ' + endOfNextMonth.format('DD/MM/YYYY'))
                    return;
                }
                //A data de compra não pode estar no mesmo mês do início da carteira
                if (moment.utc(inputPurchasedDateTitle).isSame(moment.utc(inputInitDateAssetTitle), 'month')) {
                    setOpenBackdrop(false)
                    setValidationMessage('A data de compra não pode estar no mesmo mês do início da carteira.')
                    return;
                }

                //Verificar se a data da compra é anterior ao vencimento do título 
                // console.log('inputAssetTitleToCreate.due_date: ', inputAssetTitleToCreate.due_date);
                // console.log('inputPurchasedDateTitle: ', inputPurchasedDateTitle);
                // console.log('moment is after: ', moment(inputAssetTitleToCreate.due_date).isAfter(inputPurchasedDateTitle));
                // console.log('moment is before: ', moment(inputAssetTitleToCreate.due_date).isBefore(inputPurchasedDateTitle));
                if (moment(inputAssetTitleToCreate.due_date).isBefore(inputPurchasedDateTitle)) {
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'warning',
                        message: 'A data da compra deve ser anterior ao vencimento do título'
                    }));
                    setOpenBackdrop(false)
                    return;
                }

            }

            setSubmitted(false);

            console.log("clientAccounts: ", clientAccounts);
            console.log("inputAccountNewAsset: ", inputAccountNewAsset);

            let assetTitle = {
                account_id: content.update && !inputAccountNewAsset ? content.data.account_id : clientAccounts[inputAccountNewAsset].id,
                title_id: inputAssetTitleToCreate.id,
                quantity_purchased: parseFloatByPtCurrency(inputQuantityPurchased),

                marking: optionsMarkings[inputMarkingTitle],
                purchase_date: moment.utc(inputPurchasedDateTitle).format("DD/MM/YYYY"),
                prev_purchase_date: moment.utc(prevInputPurchasedDateTitle).format("DD/MM/YYYY"),
                price_title: parseFloatByPtCurrency(inputPriceTitle),
                pre_tax: inputPreTaxTitle && inputPreTaxTitle != "" ? parseFloatByPtCurrency(inputPreTaxTitle) : null,
                indexer_percent: inputIndexerPercentTitle && inputIndexerPercentTitle != "" ? parseFloatByPtCurrency(inputIndexerPercentTitle) : null,
                with_liquidity: inputWithLiquidityTitle == 0 ? false : true,

                //datas do ativo
                asset_title_issue_date: inputAssetIssueDateTitle ? moment.utc(inputAssetIssueDateTitle).format("DD/MM/YYYY") : null,
                asset_title_sale_off_date: inputAssetSaleOffDateTitle ? moment.utc(inputAssetSaleOffDateTitle).format("DD/MM/YYYY") : null,
                asset_title_due_date: inputAssetDueDateTitle ? moment.utc(inputAssetDueDateTitle).format("DD/MM/YYYY") : null,
                asset_title_init: inputInitDateAssetTitle ? moment.utc(inputInitDateAssetTitle).format("DD/MM/YYYY") : null,
                prev_asset_title_init: prevInputInitDateAssetTitle ? moment.utc(prevInputInitDateAssetTitle).format("DD/MM/YYYY") : null,

                balance_now: balanceNow ? parseFloatByPtCurrency(balanceNow) : null,
                balance_init: balanceInit ? parseFloatByPtCurrency(balanceInit) : null,

                //Caso não tenha alterado a conta carteira o asset pode passar direto sem precisar testar se o ativo já existe no banco
                same_account: content.update && !inputAccountNewAsset ? true : clientAccounts[inputAccountNewAsset].id == content.data.selectedAccountId,

                trading_note: inputTradingNote,

                asset_name: inputAssetNameTitle,
                asset_description: inputAssetDescriptionTitle,

                eletronic_aquisition: inputEletronicAquisition == 1,
            }

            console.log("ASSET TO CREATE: ", assetTitle);

            if (content.update) {

                //Adicionando ID do asset para ser atualizado
                assetTitle.id = content.data.id;

                let response = await TitleAPI.updateAssetTitle(assetTitle);
                if (response.success) {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'success',
                        message: 'Ativo atualizado com sucesso!'
                    }));

                } else {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: response.body.message
                    }));
                }

            } else {

                let response = await TitleAPI.createAssetTitle(assetTitle);
                if (response.success) {
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'success',
                        message: 'Ativo cadastrado com sucesso!'
                    }));
                } else {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: response.body.message
                    }));
                }
            }

            dispatch(allActions.rightContentActions.update())






        }

        setOpenBackdrop(false)


    }

    async function doUpdateTradingNoteAssetTitle() {
        if (content.update) {

            let response = await TitleAPI.updateTradingNoteAssetTitle(content.data.id, inputTradingNote);
            if (response.success) {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: 'Nota de negociação atualizada com sucesso!'
                }));

            } else {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: response.body.message
                }));
            }

            dispatch(allActions.rightContentActions.update())

        }


    }

    async function doUpdateEletronicAquisitionAssetTitle() {
        if (content.update) {

            setOpenBackdrop(true)

            let response = await TitleAPI.updateEletronicAquisitionAssetTitle(content.data.id, inputEletronicAquisition == 1);
            if (response.success) {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: 'Aquisição eletrônica atualizada com sucesso!'
                }));

            } else {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: response.body.message
                }));
            }

            setOpenBackdrop(false)
            dispatch(allActions.rightContentActions.update())

        }


    }

    async function doDeleteClientAssetTitle() {

        setValidationMessage('')
        setOpenBackdrop(true)

        //console.log("CONTENT DATA: ", content.data.assetId);
        let response = await TitleAPI.deleteAssetTitle(content.data.id);
        if (response.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Ativo de Título excluído com sucesso!'
            }));
        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: response.error.message
            }));
        }

        setOpenBackdrop(false)
        dispatch(allActions.rightContentActions.update())
    }

    async function loadInfosUpdate(data, clientId, portfolioClosed) {

        setInputAssetTitleToCreate({ ...data });
        setInputQuantityPurchased(applyMaskAmount(data.quantity_purchased));
        setInputPriceTitle(applyMaskAmountFreeDecimals(data.price_title, null, 20));
        setInputPurchasedDateTitle(moment.utc(data.purchase_date));
        setPrevInputPurchasedDateTitle(moment.utc(data.purchase_date));
        setInputInitDateAssetTitle(moment.utc(data.asset_title_init));
        setPrevInputInitDateAssetTitle(moment.utc(data.asset_title_init));
        setInputPreTaxTitle(data.pre_tax ? applyMaskAmountFreeDecimals(data.pre_tax) : '')
        setInputIndexerPercentTitle(data.indexer_percent ? applyMaskAmount(data.indexer_percent) : '')
        setInputWithLiquidityTitle(data.with_liquidity ? 1 : 0)
        setInputEletronicAquisition(data.eletronic_aquisition ? 1 : 0)
        ensureEletronicPeriods(data.title_id);
        const markingIndex = optionsMarkings.findIndex(el => el === data.marking);
        setInputMarkingTitle(markingIndex != -1 ? markingIndex : 0);

        let alreadyLaunchedLocal = checkAssetIsLaunched(data.asset_title_init, portfolioClosed);
        setAlreadyLaunched(alreadyLaunchedLocal);

        setApplicationValue(parseFloat(data.price_title) * parseFloat(data.quantity_purchased))

        //datas
        setInputAssetIssueDateTitle(data.asset_title_issue_date);
        setInputAssetSaleOffDateTitle(data.asset_title_sale_off_date);
        setInputAssetDueDateTitle(data.asset_title_due_date);

        setInputTradingNote(data.trading_note);

        //genéricos
        setInputAssetNameTitle(data.asset_name)
        setInputAssetDescriptionTitle(data.asset_description)

        console.log("ALREADY LAUNCHED: ", alreadyLaunchedLocal);
        // if (!alreadyLaunchedLocal) {
        const response = await AccountAPI.listClientAccountsByRegime(clientId, null);

        console.log("RESPONSE: ", response)

        if (response.success) {

            setClientAccounts(response.body.rows)
            for (let i = 0; i < response.body.rows.length; i++) {

                if (response.body.rows[i].id == data.account_id) {
                    setInputAccountNewAsset(i);
                    break;
                }

            }

        } else {

            console.log("error: ", response.error)

        }

        //Caso seja um usuário manager ele pode acessar apenas a conta por extenso 
        if ((currentUser && currentUser.user
            && (currentUser.user.role == "ROLE_MANAGER" && currentUser.user.role == "ROLE_SUBMANAGER"))) {
            const response = await AccountAPI.getAccountById(data.account_id);
            if (response.success) {
                console.log("BODY ACCOUNT: ", response.body)
                setAccountToShow(response.body)

            } else {
                console.log("error: ", response.error)
            }
        }

        // } else {
        //     const response = await AccountAPI.getAccountById(data.account_id);
        //     if (response.success) {
        //         console.log("BODY ACCOUNT: ", response.body)
        //         //setAccountToShow(response.body.description + ' - Ag: ' + response.body.agency + ' - cc: ' + response.body.number_account)
        //         setAccountToShow(response.body)

        //     } else {
        //         console.log("error: ", response.error)
        //     }

        // }



    }

    const checkAbleToUpdate = useMemo(() => {
        if (!content?.data || !clientOn?.client) return false;
        if (!content.update) return true;
        console.log("ASSET TITLE INIT: ", moment.utc(content.data.asset_title_init))
        console.log("PORTGOLIO CLOSED: ", portfolioClosedToDate(clientOn.client.portfolio_closed))
        if (clientOn.client.portfolio_closed == null || moment.utc(content.data.asset_title_init).isSameOrAfter(portfolioClosedToDate(clientOn.client.portfolio_closed))) {
            return content.update && true;
        } else {
            return false;
        }
    }, [content, clientOn])

    function handleChangeAssetDescription(value) {
        if (value.length <= 500) {
            setInputAssetDescriptionTitle(value);
        }
    }

    //deleção do ativo de título
    function handleCancel() {
        setConfirmingAction(false);
    }

    function handleConfirm() {
        doDeleteClientAssetTitle();
    }

    async function doGetAllTitles() {

        let responseListTitles = await TitleAPI.getAllTitles();

        if (responseListTitles.success) {

            console.log("Títulos: ", responseListTitles.body.rows);
            setAllTitles(responseListTitles.body.rows)

            setInputAssetTitleToCreate(responseListTitles.body.rows[0]);
            setAssetTitleForms(prev => prev.map((form, i) =>
                i === 0 ? { ...form, inputAssetTitleToCreate: responseListTitles.body.rows[0] } : form
            ));

            if (responseListTitles.body.rows[0]) {
                ensureEletronicPeriods(responseListTitles.body.rows[0].id);
            }

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Falha ao obter lista de títulos"
            }))

        }


    }

    function isPublicTitle() {

        if (titleTypes
            &&
            (inputAssetTitleToCreate
                && inputAssetTitleToCreate.sector == "PUBLICO")
            ||
            (content && content.data && content.data.sector == "PUBLICO")) {
            return true;
        } else {
            return false;
        }

    }

    function isGeneric() {

        if (titleTypes
            &&
            inputAssetTitleToCreate) {

            const titleToTest = inputAssetTitleToCreate;

            return isGenericTitle(titleToTest);

        } else {

            return false;
        }
    }

    function isPrivacyTitle() {

        console.log("inputAssetTitleToCreate: ", inputAssetTitleToCreate);

        if (titleTypes && (inputAssetTitleToCreate && inputAssetTitleToCreate.sector == "PRIVADO")
            ||
            (content && content.data && content.data.sector == "PRIVADO")) {
            return true;
        } else {
            return false;
        }

    }

    function isMarkingCurveTitle() {

        if (optionsMarkings[inputMarkingTitle] == "CURVA") {
            return true;
        } else {
            return false;
        }

    }

    function isGenericForm(form) { return isGenericTitle(form.inputAssetTitleToCreate); }
    function isPublicTitleForm(form) { return form.inputAssetTitleToCreate?.sector === "PUBLICO"; }
    function isPrivacyTitleForm(form) { return form.inputAssetTitleToCreate?.sector === "PRIVADO"; }
    function isMarkingCurveTitleForm(form) { return optionsMarkings[form.inputMarkingTitle] === "CURVA"; }

    const handleAddIAssetTitleForm = () => {
        setAssetTitleForms(prev => [...prev, {
            ...defaultAssetTitleForm,
            inputAssetTitleToCreate: allTitles[0] || undefined,
        }]);
    };

    const handleRemoveAssetTitleForm = (index) => {
        setAssetTitleForms(prev => prev.filter((_, i) => i !== index));
    };

    const handleChangeAssetTitleForm = (index, field, value) => {
        setAssetTitleForms(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    //Busca (uma vez por título) os períodos que possuem artigo eletrônico
    async function ensureEletronicPeriods(titleId) {
        if (!titleId) return;
        if (eletronicPeriodsByTitleId[titleId] !== undefined) return;
        const response = await TitleAPI.getArticlesWithEletronic(titleId);
        setEletronicPeriodsByTitleId(prev => ({
            ...prev,
            [titleId]: response.success && response.body && response.body.rows ? response.body.rows : [],
        }));
    }

    //Indica se o título possui algum período com artigo eletrônico (independente de data)
    function hasEletronicTitle(titleId) {
        const periods = eletronicPeriodsByTitleId[titleId];
        return !!(periods && periods.length);
    }

    const renderedAssetTitleForms = useMemo(() => {
        const nodes = [];
        assetTitleForms.forEach((form, index) => {
            // Separador entre formulários
            nodes.push(
                <Grid key={`form-divider-${index}`} item lg={12} md={12} sm={12} xs={12}>
                    <Divider style={{ width: "100%", margin: "8px 0" }} />
                </Grid>
            );

            // Linha 1: Título + botão remover
            nodes.push(
                <Grid key={`form-title-${index}`} item lg={11} md={11} sm={11} xs={11}>
                    {
                        (allTitles && allTitles.length > 0) ?
                            <MyAutoComplete
                                outerlabel={'TÍTULO'}
                                onChange={(event, newValue) => {
                                    handleChangeAssetTitleForm(index, 'inputQuantityPurchased', '');
                                    if (isGenericTitle(newValue)) {
                                        handleChangeAssetTitleForm(index, 'inputQuantityPurchased', '1');
                                    }
                                    handleChangeAssetTitleForm(index, 'eletronicAquisition', 0);
                                    handleChangeAssetTitleForm(index, 'inputAssetTitleToCreate', newValue);
                                    if (newValue) {
                                        ensureEletronicPeriods(newValue.id);
                                    }
                                }}
                                options={allTitles}
                                autoComplete
                                value={form.inputAssetTitleToCreate ? form.inputAssetTitleToCreate : null}
                                getOptionLabel={(option) => {
                                    if (option.sector == 'PRIVADO') {
                                        return option.title_name;
                                    } else {
                                        return option.label_title_type + ' - ' + moment.utc(option.due_date).format('DD/MM/YYYY');
                                    }
                                }}
                                renderOption={(option) => (
                                    <React.Fragment key={'autocomplete-titles-form-' + index + '-' + option.id}>
                                        {
                                            option.sector == 'PRIVADO' ?
                                                <span>{option.title_name}</span>
                                                :
                                                <span>{option.title_name + " - " + option.label_title_type + " - " + moment.utc(option.due_date).format('DD/MM/YYYY')}</span>
                                        }
                                    </React.Fragment>
                                )}
                                renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                            />
                            : null
                    }
                </Grid>
            );

            nodes.push(
                <Grid key={`form-remove-${index}`} item lg={1} md={1} sm={1} xs={1} style={{ display: 'flex', alignItems: 'center', paddingTop: '24px' }}>
                    <IconButton
                        disabled={assetTitleForms.length === 1}
                        onClick={() => handleRemoveAssetTitleForm(index)}
                        size="small">
                        <CloseIcon />
                    </IconButton>
                </Grid>
            );

            // Informações do título (condicional)
            if (form.inputAssetTitleToCreate && !isGenericForm(form) && needQuotasTitle(form.inputAssetTitleToCreate)) {
                nodes.push(
                    <Grid key={`form-issue-info-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyInfo
                            outerlabel={'Emissão(Título)'}
                            label={form.inputAssetTitleToCreate.issue_date ? moment.utc(form.inputAssetTitleToCreate.issue_date).format('DD/MM/YYYY') : '-'} />
                    </Grid>
                );
                nodes.push(
                    <Grid key={`form-saleoff-info-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyInfo
                            outerlabel={'Liquidação(Título)'}
                            label={form.inputAssetTitleToCreate.sale_off_date ? moment.utc(form.inputAssetTitleToCreate.sale_off_date).format('DD/MM/YYYY') : '-'} />
                    </Grid>
                );
                nodes.push(
                    <Grid key={`form-due-info-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyInfo
                            outerlabel={'Vencimento(Título)'}
                            label={form.inputAssetTitleToCreate.due_date ? moment.utc(form.inputAssetTitleToCreate.due_date).format('DD/MM/YYYY') : '-'} />
                    </Grid>
                );
            }

            // Datas do ativo privado (condicional)
            if (isPrivacyTitleForm(form) && !isGenericForm(form)) {
                nodes.push(
                    <Grid key={`form-issue-date-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyDatePicker
                            defaultValue={null}
                            margin="dense"
                            outerlabel="Emissão(Ativo)"
                            format="DD/MM/YYYY"
                            value={form.inputAssetIssueDateTitle}
                            onChange={(value) => handleChangeAssetTitleForm(index, 'inputAssetIssueDateTitle', value)}
                            validator={form.inputAssetIssueDateTitle && !moment(form.inputAssetIssueDateTitle).isValid() && submitted}
                            helperText={"Insira uma data válida"}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }} />
                    </Grid>
                );
                nodes.push(
                    <Grid key={`form-saleoff-date-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyDatePicker
                            defaultValue={null}
                            margin="dense"
                            outerlabel="Liquidação(Ativo)"
                            format="DD/MM/YYYY"
                            value={form.inputAssetSaleOffDateTitle}
                            onChange={(value) => handleChangeAssetTitleForm(index, 'inputAssetSaleOffDateTitle', value)}
                            validator={form.inputAssetSaleOffDateTitle && !moment(form.inputAssetSaleOffDateTitle).isValid() && submitted}
                            helperText={"Insira uma data válida"}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }} />
                    </Grid>
                );
                nodes.push(
                    <Grid key={`form-due-date-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyDatePicker
                            defaultValue={null}
                            margin="dense"
                            outerlabel="Vencimento(Ativo)"
                            format="DD/MM/YYYY"
                            value={form.inputAssetDueDateTitle}
                            onChange={(value) => handleChangeAssetTitleForm(index, 'inputAssetDueDateTitle', value)}
                            validator={form.inputAssetDueDateTitle && !moment(form.inputAssetDueDateTitle).isValid() && submitted}
                            helperText={"Insira uma data válida"}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }} />
                    </Grid>
                );
            }

            // Linha: Marcação | Preço | Início na carteira
            nodes.push(
                <Grid key={`form-marking-${index}`} item lg={8} md={8} sm={12} xs={12}>
                    {
                        !isGenericForm(form) ?
                            <MySelect
                                outerlabel={'Marcação'}
                                value={form.inputMarkingTitle}
                                onChange={(event) => handleChangeAssetTitleForm(index, 'inputMarkingTitle', event.target.value)}
                                options={optionsMarkings.map((row, i) => (
                                    <option key={'marking-form-' + index + '-' + i} value={i}>{row}</option>
                                ))}
                                helperText={"Insira a marcação"}
                                validator={form.inputMarkingTitle == undefined && submitted ? true : undefined}
                            />
                            :
                            <MySelect
                                disabled={true}
                                outerlabel={'Marcação'}
                                value={0}
                                options={<option key={'generic-marc-form-' + index}>{'-'}</option>}
                            />
                    }
                </Grid>
            );

            nodes.push(
                <Grid key={`form-price-${index}`} item lg={4} md={4} sm={12} xs={12}>
                    <MyTextField
                        align={'right'}
                        startadornment={<InputAdornment position="start">R$</InputAdornment>}
                        size={'small'}
                        outerlabel="Preço do título"
                        outerlabelright={'true'}
                        placeholder="0,00"
                        value={form.inputPriceTitle}
                        helperText={"Insira o artigo"}
                        validator={form.inputPriceTitle == "" && submitted ? true : undefined}
                        variant="outlined"
                        onChange={(value) => {
                            if (value && value != '' && form.inputQuantityPurchased && form.inputQuantityPurchased != '') {
                                handleChangeAssetTitleForm(index, 'applicationValue', parseFloatByPtCurrency(value) * parseFloatByPtCurrency(form.inputQuantityPurchased));
                            } else {
                                handleChangeAssetTitleForm(index, 'applicationValue', '');
                            }
                            handleChangeAssetTitleForm(index, 'inputPriceTitle', value);
                        }}
                    />
                </Grid>
            );

            nodes.push(
                <Grid key={`form-init-date-${index}`} item lg={4} md={4} sm={4} xs={4}>
                    <MyDatePicker
                        margin="dense"
                        outerlabel="Início na carteira"
                        format="MM/YYYY"
                        views={["month", "year"]}
                        value={form.inputInitDateAssetTitle}
                        onChange={(value) => handleChangeAssetTitleForm(index, 'inputInitDateAssetTitle', value)}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                        validator={!moment(form.inputInitDateAssetTitle).isValid() && submitted}
                        helperText={'Data inválida'}
                    />
                </Grid>
            );

            // Linha: Saldo início | Qtd. Inicial
            nodes.push(
                <Grid key={`form-balance-init-${index}`} item lg={5} md={5} sm={12} xs={12}>
                    <MyTextField
                        align={'right'}
                        startadornment={<InputAdornment position="start">R$</InputAdornment>}
                        size={'small'}
                        outerlabel={`Saldo início carteira ${form.inputInitDateAssetTitle && moment(form.inputInitDateAssetTitle).isValid() ? '[' + moment(form.inputInitDateAssetTitle).format('MM/YYYY') + ']' : ''}`}
                        outerlabelright={'true'}
                        placeholder="0,00"
                        value={form.balanceInit}
                        helperText={"Insira o saldo inicial"}
                        validator={moment.utc(form.inputPurchasedDateTitle).isBefore(moment.utc(form.inputInitDateAssetTitle).startOf('month'))
                            && form.balanceInit == "" && submitted}
                        variant="outlined"
                        onChange={(value) => handleChangeAssetTitleForm(index, 'balanceInit', value)}
                    />
                </Grid>
            );

            nodes.push(
                <Grid key={`form-qty-init-${index}`} item lg={3} md={3} sm={12} xs={12}>
                    <MyTextField
                        align={'right'}
                        disabled={isGenericForm(form) && !isConsigTitle(form.inputAssetTitleToCreate)}
                        size={'small'}
                        outerlabel="Qtd. Inicial"
                        outerlabelright={'true'}
                        placeholder="0,00"
                        value={form.inputQuantityInit}
                        variant="outlined"
                        onChange={(value) => handleChangeAssetTitleForm(index, 'inputQuantityInit', value)}
                    />
                </Grid>
            );

            // Linha: Compra | Saldo atual | Qtd. adquirida
            nodes.push(
                <Grid key={`form-purchase-date-${index}`} item lg={4} md={4} sm={12} xs={12}>
                    <MyDatePicker
                        margin="dense"
                        outerlabel="Compra"
                        format="DD/MM/YYYY"
                        value={form.inputPurchasedDateTitle}
                        onChange={(value) => handleChangeAssetTitleForm(index, 'inputPurchasedDateTitle', value)}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                        validator={!moment(form.inputPurchasedDateTitle).isValid() && submitted}
                        helperText={'Data inválida'}
                    />
                </Grid>
            );

            nodes.push(
                <Grid key={`form-balance-now-${index}`} item lg={5} md={5} sm={12} xs={12}>
                    <MyTextField
                        align={'right'}
                        startadornment={<InputAdornment position="start">R$</InputAdornment>}
                        size={'small'}
                        outerlabel={`Saldo em ${form.inputPurchasedDateTitle && moment(form.inputPurchasedDateTitle).isValid() && moment(form.inputPurchasedDateTitle).isBefore(moment(form.inputInitDateAssetTitle)) ? '[' + moment(form.inputInitDateAssetTitle).add(1, 'month').format('MM/YYYY') + ']' : '[' + moment(form.inputPurchasedDateTitle).format('MM/YYYY') + ']'}`}
                        outerlabelright={'true'}
                        placeholder="0,00"
                        value={form.balanceNow}
                        helperText={"Insira o saldo"}
                        variant="outlined"
                        onChange={(value) => handleChangeAssetTitleForm(index, 'balanceNow', value)}
                    />
                </Grid>
            );

            nodes.push(
                <Grid key={`form-qty-${index}`} item lg={3} md={3} sm={12} xs={12}>
                    <MyTextField
                        align={'right'}
                        disabled={isGenericForm(form) && !isConsigTitle(form.inputAssetTitleToCreate)}
                        size={'small'}
                        outerlabel="Qtd. adquirida"
                        outerlabelright={'true'}
                        placeholder="0,00"
                        value={form.inputQuantityPurchased}
                        variant="outlined"
                        validator={form.inputQuantityPurchased == "" && submitted}
                        helperText="Um valor deve ser informado"
                        onChange={(value) => {
                            if (form.inputPriceTitle && form.inputPriceTitle != '' && value && value != '') {
                                handleChangeAssetTitleForm(index, 'applicationValue', parseFloatByPtCurrency(form.inputPriceTitle) * parseFloatByPtCurrency(value));
                            } else {
                                handleChangeAssetTitleForm(index, 'applicationValue', '');
                            }
                            handleChangeAssetTitleForm(index, 'inputQuantityPurchased', value);
                        }}
                    />
                </Grid>
            );

            // Conta
            nodes.push(
                <Grid key={`form-account-${index}`} item lg={8} md={8} sm={12} xs={12}>
                    <MySelect
                        outerlabel={'Conta'}
                        value={form.inputAccountNewAsset}
                        initblank={'true'}
                        validator={(form.inputAccountNewAsset == null || form.inputAccountNewAsset === '') && submitted}
                        helperText="Informe a conta"
                        onChange={(e) => handleChangeAssetTitleForm(index, 'inputAccountNewAsset', e.target.value)}
                        options={clientAccounts.map((row, i) => (
                            <option key={'account-form-' + index + '-' + row.id} value={i}>
                                {row.description + (row.agency ? ' - Ag: ' + row.agency : "") + ' - CC: ' + row.number_account}
                            </option>
                        ))}
                    />
                </Grid>
            );

            // Campos condicionais de indexadores
            if (!isGenericForm(form) && ((isPublicTitleForm(form) && isMarkingCurveTitleForm(form))
                || (!isPublicTitleForm(form) && form.inputAssetTitleToCreate
                    && (form.inputAssetTitleToCreate.indexer == null || form.inputAssetTitleToCreate.indexer == 'IPCA')))) {
                nodes.push(
                    <Grid key={`form-pretax-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyTextField
                            align={'right'}
                            size={'small'}
                            outerlabel="Taxa pré"
                            placeholder="0,00"
                            outerlabelright={'true'}
                            value={form.inputPreTaxTitle}
                            onChange={(value) => handleChangeAssetTitleForm(index, 'inputPreTaxTitle', value)}
                        />
                    </Grid>
                );
            }

            if (!isGenericForm(form) && !isPublicTitleForm(form) && isMarkingCurveTitleForm(form)
                && form.inputAssetTitleToCreate && form.inputAssetTitleToCreate.indexer === "CDI") {
                nodes.push(
                    <Grid key={`form-indexer-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MyTextField
                            align={'right'}
                            size={'small'}
                            outerlabel={"(%) " + form.inputAssetTitleToCreate.indexer}
                            placeholder="0,00"
                            outerlabelright={'true'}
                            value={form.inputIndexerPercentTitle}
                            onChange={(value) => handleChangeAssetTitleForm(index, 'inputIndexerPercentTitle', value)}
                        />
                    </Grid>
                );
            }

            if (!isGenericForm(form) && !isPublicTitleForm(form) && isMarkingCurveTitleForm(form)) {
                nodes.push(
                    <Grid key={`form-liquidity-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MySelect
                            outerlabel={'Liquidez'}
                            value={form.inputWithLiquidityTitle}
                            onChange={(e) => handleChangeAssetTitleForm(index, 'inputWithLiquidityTitle', e.target.value)}
                            options={optionsLiquidity.map((row, i) => (
                                <option key={'liquidity-form-' + index + '-' + i} value={i}>{row}</option>
                            ))}
                        />
                    </Grid>
                );
            }

            // Campos genéricos
            if (isGenericForm(form)) {
                nodes.push(
                    <Grid key={`form-name-${index}`} item lg={12} md={12} sm={12} xs={12}>
                        <MyTextField
                            outerlabel={"Nome"}
                            placeholder="Insira o nome do ativo"
                            value={form.inputAssetNameTitle}
                            onChange={(value) => handleChangeAssetTitleForm(index, 'inputAssetNameTitle', value)}
                        />
                    </Grid>
                );
                nodes.push(
                    <Grid key={`form-desc-${index}`} item lg={12} md={12} sm={12} xs={12}>
                        <MyTextField
                            outerlabel={"Descrição"}
                            value={form.inputAssetDescriptionTitle}
                            multiline={true}
                            rows={5}
                            rowsMax={5}
                            onChange={(value) => {
                                if (value.length <= 500) handleChangeAssetTitleForm(index, 'inputAssetDescriptionTitle', value);
                            }}
                        />
                        <span style={{ float: 'right', fontSize: '12px' }}>Caracteres {form.inputAssetDescriptionTitle.length}/500</span>
                    </Grid>
                );
            }

            nodes.push(
                <Grid key={`form-app-value-${index}`} item lg={8} md={8} sm={12} xs={12}>
                    <div style={{ textAlign: 'right' }}>
                        <span>Valor aplicação: <h3 style={{ color: unoTheme.greenMoney }}>{form.applicationValue ? applyMaskAmountFreeDecimals(form.applicationValue, true) : '-'}</h3></span>
                    </div>
                </Grid>
            );

            const showEletronicForm = !isGenericForm(form)
                && form.inputAssetTitleToCreate
                && hasEletronicTitle(form.inputAssetTitleToCreate.title_id || form.inputAssetTitleToCreate.id);

            nodes.push(
                <Grid key={`form-trading-note-${index}`} item lg={showEletronicForm ? 8 : 12} md={showEletronicForm ? 8 : 12} sm={12} xs={12}>
                    <MyTextField
                        outerlabel={"Nota de negociação"}
                        placeholder="Insira a nota de negociação"
                        value={form.inputTradingNote}
                        onChange={(value) => handleChangeAssetTitleForm(index, 'inputTradingNote', value)}
                    />
                </Grid>
            );

            // Aquisição eletrônica ao lado da nota de negociação (só se o título tiver artigo eletrônico)
            if (showEletronicForm) {
                nodes.push(
                    <Grid key={`form-eletronic-${index}`} item lg={4} md={4} sm={12} xs={12}>
                        <MySelect
                            outerlabel={'Aquisição eletrônica'}
                            value={form.eletronicAquisition}
                            onChange={(e) => handleChangeAssetTitleForm(index, 'eletronicAquisition', e.target.value)}
                            options={optionsYesNo.map((row, i) => (
                                <option key={'eletronic-form-' + index + '-' + i} value={i}>{row}</option>
                            ))}
                        />
                    </Grid>
                );
            }
        });

        return nodes;
    }, [assetTitleForms, submitted, clientAccounts, allTitles, optionsMarkings, optionsLiquidity, optionsYesNo, eletronicPeriodsByTitleId]);

    useEffect(() => {

        console.log("DATA NEW ASSET: ", content)

        //Caso de update de Asset (Asset só pode ser alterado caso ainda não tenha movimentações cadastrdas para ele)
        if (content
            && content.update
            && clientOn && clientOn.client) {

            //Iniciar seletor de conta com a atual conta selecionada [content.data.selectedAccountId]  
            loadInfosUpdate(content.data, clientOn.client.id, clientOn.client.portfolio_closed);

        } else {

            setClientAccounts(content.data.accounts);
            doGetAllTitles();

        }

    }, [])

    return (
        <div className={classes.root}>


            {
                !confirmingAction ?
                    <>
                        {content && content.update ?

                            null
                            // <div style={{ height: '24px' }}></div>

                            :

                            <div className={classes.header}>

                                <IconButton className={content && content.data && content.update ? "" : classes.hiddenIcon}
                                    onClick={() => dispatch(allActions.rightContentActions.setRightContent(content.data.dataToBack))}>
                                    <ArrowBackIcon />
                                </IconButton>

                                <div>
                                    <Typography
                                        variant={'h6'}
                                        align={'left'}>
                                        {content && content.data && content.update ? "Editar Ativo de Título" : "Cadastrar Ativo de Título"}

                                    </Typography>

                                </div>


                                <IconButton
                                    className={content && content.data && content.update ? classes.hiddenIcon : ""}
                                    onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                    <CloseIcon />
                                </IconButton>

                            </div>
                        }

                        <div className={classes.main} style={content && content.data && content.update
                            ? { paddingTop: '24px', height: 'calc(100vh - 148px)' }
                            : { height: 'calc(100vh - 96px)' }}>


                            <Grid container spacing={2}>

                                {content && content.update ? <>

                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        {
                                            (allTitles && allTitles.length > 0) ?


                                                <MyAutoComplete
                                                    outerlabel={'TíTULO'}
                                                    onChange={(event, newValue) => {
                                                        setInputQuantityPurchased('');
                                                        if (isGenericTitle(newValue)) {
                                                            setInputQuantityPurchased('1');
                                                        }
                                                        setInputEletronicAquisition(0);
                                                        setInputAssetTitleToCreate(newValue);
                                                        if (newValue) {
                                                            ensureEletronicPeriods(newValue.id);
                                                        }
                                                    }}
                                                    //normallayout={'true'}
                                                    options={allTitles}
                                                    autoComplete
                                                    value={inputAssetTitleToCreate ? inputAssetTitleToCreate : null}
                                                    //includeInputInList
                                                    getOptionLabel={(option) => {
                                                        if (option.sector == 'PRIVADO') {
                                                            return option.title_name;
                                                        } else {
                                                            return option.label_title_type + ' - ' + moment.utc(option.due_date).format('DD/MM/YYYY');
                                                        }

                                                    }}
                                                    renderOption={(option) => (
                                                        <React.Fragment key={'autocomplete-titles-' + option.id}>
                                                            {
                                                                option.sector == 'PRIVADO' ?
                                                                    <span className={classes.textAutoComplete}>{option.title_name}</span>
                                                                    :
                                                                    <span className={classes.textAutoComplete}>{option.title_name + " - " + option.label_title_type + " - " + moment.utc(option.due_date).format('DD/MM/YYYY')}</span>
                                                            }

                                                        </React.Fragment>
                                                    )}
                                                    renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                                                />
                                                :
                                                <MyInfo
                                                    outerlabel={'TÍTULO'}
                                                    label={content && content.data ? content.data.title_name : ''}>

                                                </MyInfo>

                                        }
                                    </Grid>



                                    {
                                        inputAssetTitleToCreate && !isGeneric() && needQuotasTitle(inputAssetTitleToCreate) ?
                                            <>
                                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                                    <MyInfo
                                                        outerlabel={'Emissão(Título)'}
                                                        label={inputAssetTitleToCreate && inputAssetTitleToCreate.issue_date ? moment.utc(inputAssetTitleToCreate.issue_date).format('DD/MM/YYYY') : '-'}>

                                                    </MyInfo>
                                                </Grid>

                                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                                    <MyInfo
                                                        outerlabel={'Liquidação(Título)'}
                                                        label={inputAssetTitleToCreate && inputAssetTitleToCreate.sale_off_date ? moment.utc(inputAssetTitleToCreate.sale_off_date).format('DD/MM/YYYY') : '-'}>

                                                    </MyInfo>
                                                </Grid>

                                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                                    <MyInfo
                                                        outerlabel={'Vencimento(Título)'}
                                                        label={inputAssetTitleToCreate && inputAssetTitleToCreate.due_date ? moment.utc(inputAssetTitleToCreate.due_date).format('DD/MM/YYYY') : '-'}>

                                                    </MyInfo>
                                                </Grid>
                                            </> : null
                                    }

                                    {
                                        isPrivacyTitle() && !isGeneric() ?
                                            <>
                                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                                    <MyDatePicker
                                                        defaultValue={null}
                                                        className={classes.myDatePicker}
                                                        margin="dense"
                                                        outerlabel="Emissão(Ativo)"
                                                        format="DD/MM/YYYY"
                                                        disabled={edittingAccount}
                                                        value={inputAssetIssueDateTitle}
                                                        onChange={(value) => setInputAssetIssueDateTitle(value)}
                                                        validator={inputAssetIssueDateTitle && !moment(inputAssetIssueDateTitle).isValid() && submitted}
                                                        helperText={"Insira uma data válida"}
                                                        KeyboardButtonProps={{ 'aria-label': 'change date', }} />


                                                </Grid>



                                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                                    <MyDatePicker
                                                        defaultValue={null}
                                                        className={classes.myDatePicker}
                                                        margin="dense"
                                                        disabled={edittingAccount}
                                                        outerlabel="Liquidação(Ativo)"
                                                        format="DD/MM/YYYY"
                                                        value={inputAssetSaleOffDateTitle}
                                                        onChange={(value) => setInputAssetSaleOffDateTitle(value)}
                                                        validator={inputAssetSaleOffDateTitle && !moment(inputAssetSaleOffDateTitle).isValid() && submitted}
                                                        helperText={"Insira uma data válida"}
                                                        KeyboardButtonProps={{ 'aria-label': 'change date', }} />

                                                </Grid>


                                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                                    <MyDatePicker
                                                        defaultValue={null}
                                                        className={classes.myDatePicker}
                                                        margin="dense"
                                                        disabled={edittingAccount}
                                                        outerlabel="Vencimento(Ativo)"
                                                        format="DD/MM/YYYY"
                                                        value={inputAssetDueDateTitle}
                                                        onChange={(value) => setInputAssetDueDateTitle(value)}
                                                        validator={inputAssetDueDateTitle && !moment(inputAssetDueDateTitle).isValid() && submitted}
                                                        helperText={"Insira uma data válida"}
                                                        KeyboardButtonProps={{ 'aria-label': 'change date', }} />

                                                </Grid>
                                            </> : null
                                    }





                                    <Grid item lg={8} md={8} sm={12} xs={12}>
                                        {
                                            !isGeneric() ?
                                                <MySelect
                                                    disabled={isPrivacyTitle() || !checkAbleToUpdate || edittingAccount}
                                                    outerlabel={'Marcação'}
                                                    value={inputMarkingTitle}
                                                    onChange={(event) => setInputMarkingTitle(event.target.value)}
                                                    options={optionsMarkings.map((row, index) => (
                                                        <option key={'kingcation-title-select-' + index} value={index}>{row}</option>
                                                    ))}
                                                    helperText={"Insira a marcação"}
                                                    validator={inputMarkingTitle == undefined && submitted ? true : undefined}
                                                />
                                                :
                                                <MySelect
                                                    disabled={true}
                                                    outerlabel={'Marcação'}
                                                    value={0}
                                                    options={
                                                        <option key={'generic-marc-1'}>{'-'}</option>
                                                    }
                                                />
                                        }


                                    </Grid>

                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <MyTextField
                                            align={'right'}
                                            startadornment={<InputAdornment position="start">R$</InputAdornment>}
                                            size={'small'}
                                            //disabled={!checkAbleToUpdate || edittingAccount}
                                            disabled={edittingAccount}
                                            outerlabel="Preço do título"
                                            outerlabelright={'true'}
                                            placeholder="0,00"
                                            value={inputPriceTitle}
                                            helperText={"Insira o artigo"}
                                            validator={inputPriceTitle == "" && submitted ? true : undefined}
                                            variant="outlined"
                                            onChange={(value) => {
                                                if (value && value != ''
                                                    && inputQuantityPurchased && inputQuantityPurchased != '') {
                                                    setApplicationValue(parseFloatByPtCurrency(value) * parseFloatByPtCurrency(inputQuantityPurchased))
                                                } else {
                                                    setApplicationValue('');
                                                }
                                                setInputPriceTitle(value)
                                            }}
                                        //mask={["currency"]} 
                                        />
                                    </Grid>

                                    <Grid item lg={4} md={4} sm={4} xs={4}>
                                        <MyDatePicker
                                            className={classes.myDatePicker}
                                            margin="dense"
                                            outerlabel="Início na carteira"
                                            format="MM/YYYY"
                                            views={["month", "year"]}
                                            value={inputInitDateAssetTitle}
                                            disabled={edittingAccount}
                                            onChange={(value) => setInputInitDateAssetTitle(value)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date', }}
                                            validator={!moment(inputInitDateAssetTitle).isValid() && submitted}
                                            helperText={'Data inválida'}
                                        />
                                    </Grid>

                                    <Grid item lg={5} md={5} sm={12} xs={12}>
                                        <MyTextField
                                            align={'right'}
                                            startadornment={<InputAdornment position="start">R$</InputAdornment>}
                                            size={'small'}
                                            disabled={edittingAccount || content.update}
                                            outerlabel={`Saldo início carteira ${inputInitDateAssetTitle && moment(inputInitDateAssetTitle).isValid() ? '[' + moment(inputInitDateAssetTitle).format('MM/YYYY') + ']' : ''}`}
                                            outerlabelright={'true'}
                                            placeholder="0,00"
                                            value={balanceInit}
                                            helperText={"Insira o saldo inicial"}
                                            validator={balanceInit == "" && submitted ? true : undefined}
                                            variant="outlined"
                                            onChange={(value) => {
                                                setBalanceInit(value)
                                            }}
                                        //mask={["currency"]} 
                                        />
                                    </Grid>

                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <MyTextField
                                            align={'right'}
                                            disabled={(isGeneric() && !isConsigTitle(inputAssetTitleToCreate)) || !checkAbleToUpdate || edittingAccount}
                                            // startadornment={<InputAdornment position="start">R$</InputAdornment>}
                                            size={'small'}
                                            outerlabel="Qtd. Inicial"
                                            outerlabelright={'true'}
                                            placeholder="0,00"
                                            value={inputQuantityInit}
                                            variant="outlined"
                                            validator={inputQuantityInit == "" && submitted}
                                            helperText="Um valor deve ser informado"
                                            onChange={(value) => {
                                                setInputQuantityInit(value)
                                            }}
                                        />

                                    </Grid>

                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <MyDatePicker
                                            className={classes.myDatePicker}
                                            margin="dense"
                                            outerlabel="Compra"
                                            format="DD/MM/YYYY"
                                            disabled={edittingAccount}
                                            value={inputPurchasedDateTitle}
                                            onChange={(value) => setInputPurchasedDateTitle(value)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date', }}
                                            validator={!moment(inputPurchasedDateTitle).isValid() && submitted}
                                            helperText={'Data inválida'}
                                        />


                                    </Grid>

                                    <Grid item lg={5} md={5} sm={12} xs={12}>
                                        <MyTextField
                                            align={'right'}
                                            startadornment={<InputAdornment position="start">R$</InputAdornment>}
                                            size={'small'}
                                            disabled={edittingAccount || content.update}
                                            outerlabel={`Saldo em ${inputPurchasedDateTitle && moment(inputPurchasedDateTitle).isValid() && moment(inputPurchasedDateTitle).isBefore(moment(inputInitDateAssetTitle)) ? '[' + moment(inputInitDateAssetTitle).add(1, 'month').format('MM/YYYY') + ']' : '[' + moment(inputPurchasedDateTitle).format('MM/YYYY') + ']'}`}
                                            outerlabelright={'true'}
                                            placeholder="0,00"
                                            value={balanceNow}
                                            helperText={"Insira o saldo"}
                                            validator={balanceNow == "" && submitted ? true : undefined}
                                            variant="outlined"
                                            onChange={(value) => {
                                                setBalanceNow(value)
                                            }}
                                        //mask={["currency"]} 
                                        />
                                    </Grid>


                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <MyTextField
                                            align={'right'}
                                            disabled={(isGeneric() && !isConsigTitle(inputAssetTitleToCreate)) || !checkAbleToUpdate || edittingAccount}
                                            // startadornment={<InputAdornment position="start">R$</InputAdornment>}
                                            size={'small'}
                                            outerlabel="Qtd. adquirida"
                                            outerlabelright={'true'}
                                            placeholder="0,00"
                                            value={inputQuantityPurchased}
                                            variant="outlined"
                                            validator={inputQuantityPurchased == "" && submitted}
                                            helperText="Um valor deve ser informado"
                                            onChange={(value) => {
                                                if (inputPriceTitle && inputPriceTitle != ''
                                                    && value && value != '') {
                                                    setApplicationValue(parseFloatByPtCurrency(inputPriceTitle) * parseFloatByPtCurrency(value))
                                                } else {
                                                    setApplicationValue('');
                                                }
                                                setInputQuantityPurchased(value)
                                            }}
                                        />

                                    </Grid>

                                    {
                                        content && content.data
                                            && content.update && (currentUser && currentUser.user
                                                && (currentUser.user.role == "ROLE_MANAGER" || currentUser.user.role == "ROLE_SUBMANAGER")) ?

                                            <Grid item lg={8} md={8} sm={12} xs={12}>
                                                <Grid container spacing={0}>
                                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                                        <MyInfo
                                                            outerlabel={'Instituição (CC)'}
                                                            label={accountToShow.description}>

                                                        </MyInfo>
                                                    </Grid>
                                                    <Grid item lg={3} md={3} sm={3} xs={3}>
                                                        <MyInfo
                                                            align={'right'}
                                                            outerlabel={'Agência'}
                                                            label={accountToShow.agency ? accountToShow.agency : "-"}>

                                                        </MyInfo>
                                                    </Grid>
                                                    <Grid item lg={3} md={3} sm={3} xs={3}>
                                                        <MyInfo
                                                            align={'right'}
                                                            outerlabel={'CC'}
                                                            label={accountToShow.number_account ? applyMaskAccount(accountToShow.number_account) : null}>

                                                        </MyInfo>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            :

                                            <Grid item lg={8} md={8} sm={12} xs={12} >
                                                <MySelect
                                                    disabled={!checkAbleToUpdate && !edittingAccount}
                                                    outerlabel={'Conta'}
                                                    value={inputAccountNewAsset}
                                                    initblank={'true'}
                                                    validator={inputAccountNewAsset == null && submitted}
                                                    helperText="Informe a conta"
                                                    onChange={(e) => setInputAccountNewAsset(e.target.value)}
                                                    options={clientAccounts.map((row, index) => (
                                                        <option key={'account-new-transaction-' + row.id} value={index}>
                                                            {row.description + (row.agency ? ' - Ag: ' + row.agency : "") + ' - CC: ' + row.number_account}
                                                        </option>
                                                    ))}

                                                />
                                            </Grid>
                                    }

                                    {
                                        !isGeneric() && ((isPublicTitle() &&
                                            isMarkingCurveTitle())
                                            || (!isPublicTitle() && (inputAssetTitleToCreate
                                                && (
                                                    inputAssetTitleToCreate.indexer == null
                                                    ||
                                                    inputAssetTitleToCreate.indexer == 'IPCA'
                                                )))) ?

                                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                                <MyTextField
                                                    align={'right'}
                                                    size={'small'}
                                                    outerlabel="Taxa pré"
                                                    placeholder="0,00"
                                                    outerlabelright={'true'}
                                                    value={inputPreTaxTitle}
                                                    disabled={!checkAbleToUpdate || edittingAccount}
                                                    onChange={(value) => setInputPreTaxTitle(value)}
                                                // validator={inputPreTaxTitle == "" && submitted}
                                                // helperText="Informe a taxa"
                                                />
                                            </Grid> : null
                                    }

                                    {
                                        !isGeneric() && (!isPublicTitle() &&
                                            isMarkingCurveTitle() && inputAssetTitleToCreate && (inputAssetTitleToCreate.indexer && inputAssetTitleToCreate.indexer == "CDI"
                                                || (content && content.data && content.data.indexer && content.data.indexer == "CDI"))) ?


                                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                                <MyTextField
                                                    align={'right'}
                                                    size={'small'}
                                                    outerlabel={"(%) " +
                                                        (
                                                            (inputAssetTitleToCreate && inputAssetTitleToCreate.indexer)
                                                            ||
                                                            (content && content.data && content.data.indexer)
                                                        )
                                                    }
                                                    disabled={!checkAbleToUpdate || edittingAccount}
                                                    placeholder="0,00"
                                                    outerlabelright={'true'}
                                                    value={inputIndexerPercentTitle}
                                                    onChange={(value) => setInputIndexerPercentTitle(value)}
                                                // validator={inputPreTaxTitle == "" && submitted}
                                                // helperText="Informe a taxa"
                                                />
                                            </Grid> : null
                                    }

                                    {
                                        !isGeneric() && !isPublicTitle() &&
                                            isMarkingCurveTitle() ?

                                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                                <MySelect
                                                    disabled={!checkAbleToUpdate || edittingAccount}
                                                    outerlabel={'Liquidez'}
                                                    value={inputWithLiquidityTitle}
                                                    onChange={(e) => setInputWithLiquidityTitle(e.target.value)}
                                                    options={optionsLiquidity.map((row, index) => (
                                                        <option key={'options-liquidity-' + index} value={index}>
                                                            {row}
                                                        </option>
                                                    ))}

                                                />
                                            </Grid> : null
                                    }

                                    {
                                        isGeneric() ?
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <MyTextField
                                                    disabled={edittingAccount}
                                                    outerlabel={"Nome"}
                                                    placeholder="Insira o nome do ativo"
                                                    value={inputAssetNameTitle}
                                                    onChange={(value) => setInputAssetNameTitle(value)}
                                                />
                                            </Grid> : null

                                    }

                                    {
                                        isGeneric() ?
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <MyTextField
                                                    outerlabel={"Descrição"}
                                                    value={inputAssetDescriptionTitle}
                                                    multiline={true}
                                                    rows={5}
                                                    disabled={edittingAccount}
                                                    rowsMax={5}
                                                    onChange={(value) => handleChangeAssetDescription(value)}
                                                />
                                                <span style={{ float: 'right', fontSize: '12px' }}>Caracteres {inputAssetDescriptionTitle.length}/500</span>
                                            </Grid> : null

                                    }

                                    <Grid item lg={8} md={8} sm={12} xs={12}>

                                        <div style={{ textAlign: 'right' }}>
                                            <span>Valor aplicação: <h3 style={{ color: unoTheme.greenMoney }}>{applicationValue ? applyMaskAmountFreeDecimals(applicationValue, true) : '-'}</h3></span>
                                        </div>
                                    </Grid>

                                    <Grid item
                                        lg={!isGeneric() && inputAssetTitleToCreate && hasEletronicTitle(inputAssetTitleToCreate.title_id || inputAssetTitleToCreate.id) ? 8 : 12}
                                        md={!isGeneric() && inputAssetTitleToCreate && hasEletronicTitle(inputAssetTitleToCreate.title_id || inputAssetTitleToCreate.id) ? 8 : 12}
                                        sm={12} xs={12}>
                                        <MyTextField
                                            disabled={edittingAccount}
                                            outerlabel={"Nota de negociação"}
                                            placeholder="Insira a nota de negociação"
                                            value={inputTradingNote}
                                            onChange={(value) => setInputTradingNote(value)}
                                        />
                                    </Grid>

                                    {
                                        !isGeneric()
                                            && inputAssetTitleToCreate
                                            && hasEletronicTitle(inputAssetTitleToCreate.title_id || inputAssetTitleToCreate.id) ?

                                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                                <MySelect
                                                    disabled={edittingAccount}
                                                    outerlabel={'Aquisição eletrônica'}
                                                    value={inputEletronicAquisition}
                                                    onChange={(e) => setInputEletronicAquisition(e.target.value)}
                                                    options={optionsYesNo.map((row, index) => (
                                                        <option key={'options-eletronic-' + index} value={index}>
                                                            {row}
                                                        </option>
                                                    ))}
                                                />
                                            </Grid> : null
                                    }

                                    {
                                        checkUserIsRole(currentUser, [roles.admin, roles.advisor, roles.superadmin]) && content.data && content.update && !edittingAccount ?
                                            <UnoButton
                                                style={{ marginLeft: "8px" }}
                                                onClick={() => doUpdateTradingNoteAssetTitle()}
                                                type='primary'>
                                                {"Atualizar Nota"}
                                            </UnoButton> : null
                                    }

                                    {
                                        checkUserIsRole(currentUser, [roles.admin, roles.advisor, roles.superadmin])
                                            && content.data && content.update && !edittingAccount
                                            && !isGeneric()
                                            && inputAssetTitleToCreate
                                            && hasEletronicTitle(inputAssetTitleToCreate.title_id || inputAssetTitleToCreate.id) ?
                                            <UnoButton
                                                style={{ marginLeft: "8px" }}
                                                onClick={() => doUpdateEletronicAquisitionAssetTitle()}
                                                type='success'>
                                                {"Atualizar aquisição eletrônica"}
                                            </UnoButton> : null
                                    }

                                    {content.data && content.update ?
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Typography style={{ color: unoTheme.defaultTextColor }} variant={'body1'}>
                                                {'A edição do ATIVO só é permitida no caso em que ainda não foi fechada nenhuma carteira que o contenha, assim como nenhuma movimentação relacionada a ele'}
                                            </Typography>
                                        </Grid>
                                        : null
                                    }

                                </> : <>{renderedAssetTitleForms}</>}
                            </Grid>

                            <br />

                            {
                                currentUser && currentUser.user
                                    && (currentUser.user.role == "ROLE_ADMIN"
                                        || currentUser.user.role == "ROLE_SUPER_ADMIN"
                                        || currentUser.user.role == "ROLE_ADVISOR") ?
                                    <div className={classes.bottom}>

                                        {
                                            validationMessage != '' ?
                                                <Typography className={classes.validationMessage}>
                                                    {validationMessage}
                                                </Typography>
                                                : null

                                        }

                                        {

                                            content.data && content.update ?
                                                <>
                                                    {
                                                        content && content.data && content.update
                                                            //&& !alreadyLaunched
                                                            ?

                                                            <div className={'bottomButtons'}>
                                                                {
                                                                    !edittingAccount ?
                                                                        <UnoButton
                                                                            onClick={() => setConfirmingAction(true)}
                                                                            type='errorClean'>
                                                                            {"Excluir ativo"}
                                                                        </UnoButton>
                                                                        :
                                                                        <UnoButton
                                                                            onClick={() => setEdittingAccount(false)}
                                                                            type='errorClean'>
                                                                            {"Cancelar"}
                                                                        </UnoButton>
                                                                }

                                                                {
                                                                    !edittingAccount ?
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                                                                            {
                                                                                checkUserIsRole(currentUser, [roles.admin, roles.advisor, roles.superadmin]) &&
                                                                                <UnoButton
                                                                                    onClick={() => setEdittingAccount(true)}
                                                                                    type='warning'>
                                                                                    {"Atualizar conta"}
                                                                                </UnoButton>
                                                                            }
                                                                            <UnoButton
                                                                                onClick={() => doSaveClientAsset()}
                                                                                type='success'>
                                                                                {"Atualizar Ativo"}
                                                                            </UnoButton>
                                                                        </div>
                                                                        :
                                                                        <UnoButton
                                                                            onClick={() => doUpdateAccount()}
                                                                            type='success'>
                                                                            {"Finalizar"}
                                                                        </UnoButton>
                                                                }
                                                            </div>
                                                            : null

                                                    }

                                                </>
                                                :

                                                <div style={{ display: "flex", gap: '8px', alignItems: "center" }}>
                                                    <UnoButton
                                                        float="right"
                                                        startIcon={<AddIcon />}
                                                        onClick={() => handleAddIAssetTitleForm()}
                                                        type='defaultClean'>
                                                        {"Adicionar registro"}
                                                    </UnoButton>
                                                    <UnoButton
                                                        onClick={() => doSaveClientAsset()}
                                                        type='primary'>
                                                        {assetTitleForms.length === 1 ? "Salvar Ativo" : `Salvar Ativos [${assetTitleForms.length}]`}
                                                    </UnoButton>
                                                </div>
                                        }


                                    </div>
                                    : null
                            }


                        </div>

                        {
                            openBackdrop ?
                                <div className={classes.rightDivBackdrop}>
                                    <CircularProgress className={'progress'} />
                                </div> : null
                        }
                    </>

                    :

                    <ConfirmActionRightContent
                        message={`Tem certeza que quer excluir 
                        esse ativo?`}
                        handleCancel={handleCancel}
                        handleConfirm={handleConfirm}
                    />
            }

        </div >
    );
}



